module.exports = __webpack_public_path__ + "66e8b2e3e49f6f6b395e9abd770acf37.pdf";